var app = angular.module("leonardo");

var ResetPasswordController = function($scope, $location, $http, ConfigThemeService, LoginService, $state, NotificationService,
                                       FormErrorsService, $timeout, AnalyticsService) {
  $scope.data = {
    password: '',
    confirm_password: ''
  };
  
  $scope.data.token = $state.params.token;
  $scope.data.uidb64 = $state.params.uidb64;

  $scope.errorPassword = function() {
    return $scope.data.password != $scope.data.confirm_password;
  };

  $scope.goToHome = function(){
    $timeout(function () {
      $state.go('home');
    }, 100);
  };

  $scope.submit = function() {
    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    if ($scope.errorPassword()) return;
    var url = ConfigThemeService.generateURL('/api/2.0/reset-password/');
    var data = angular.copy($scope.data);
    data['noerror'] = true;
    $http.post(url, data).then(function(user) {
      user = user.data;
      if($state.current.name === 'password_create') {
        AnalyticsService.identifyUser(user); 
        AnalyticsService.track('User Registered');
      } else {
        AnalyticsService.track('Password Reset Succeeded');
      }
      LoginService.login(user.email, data.password);
    }).catch(function(error) {
      if (error.password) {
        NotificationService.error('Password must contain a minimum of 8 characters, at least 1 letter and 1 number.');
      }
      else {
        NotificationService.error(error);
      }
    });
  };
};

app.controller('ResetPasswordController', ['$scope', '$location', '$http', 'ConfigThemeService', 'LoginService', '$state',
  'NotificationService', 'FormErrorsService', '$timeout', 'AnalyticsService', ResetPasswordController]);